import React from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonToolbar, Table } from "components/bootstrap";
const InputsTable = ({
  inputs,
  inputTypes,
  onInputDelete = () => {
  },
  onInputEdit = () => {
  },
  withActions = false
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  return /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("inputs_table.title")), /* @__PURE__ */ React.createElement("th", null, t("inputs_table.type")), withActions && /* @__PURE__ */ React.createElement("th", null, "\xA0"))), /* @__PURE__ */ React.createElement("tbody", null, inputs.map((input) => {
    const { title, type } = input;
    return /* @__PURE__ */ React.createElement("tr", { key: title }, /* @__PURE__ */ React.createElement("td", null, title), /* @__PURE__ */ React.createElement("td", null, inputTypes[type] ? inputTypes[type] : type), withActions && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xs", onClick: () => onInputDelete(input) }, t("inputs_table.delete")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "xs", onClick: () => onInputEdit(input) }, t("inputs_table.edit")))));
  })));
};
export default InputsTable;
